import { dehydrate } from '@tanstack/react-query'

import { fetchAdFormatsList } from 'src/lib/react-query/api'
import { mapAdFormatsCollectionToCards } from 'src/lib/react-query/adFormatsList'
import { getQueryClient } from 'src/lib/react-query/client'
import { getHeaderDataQuery, queryKeys } from 'src/lib/react-query/queries'
import AdFormatsListPage from 'src/components/pages/AdFormatsListPage'
import Header from 'src/components/navigation/header/Header'
import { parseErrorToServerFunction } from 'src/lib/api'

import type { GridCard } from 'src/components/common/grid/Grid'
import type { HeaderData } from 'src/components/navigation/header/headerHelpers'
import type { GetServerSideProps } from 'next'

const Slug = ({ cards, headerData }: { cards: GridCard[]; headerData: HeaderData }) => {
  return (
    <>
      <Header headerData={headerData} />
      <AdFormatsListPage cards={cards} />
    </>
  )
}

export default Slug

export const getServerSideProps: GetServerSideProps = async () => {
  const queryClient = getQueryClient()

  const [, adFormatsResult] = await Promise.all([
    queryClient.prefetchQuery({
      queryKey: queryKeys.menu,
      queryFn: getHeaderDataQuery
    }),
    fetchAdFormatsList()
  ])

  const headerData = queryClient.getQueryData(queryKeys.menu)

  if (adFormatsResult.isError && adFormatsResult.error) {
    return parseErrorToServerFunction(adFormatsResult.error)
  }

  const cards = adFormatsResult.data ? mapAdFormatsCollectionToCards(adFormatsResult.data) : []

  return {
    props: {
      slug: 'ad-formats',
      cards,
      headerData,
      dehydratedState: dehydrate(queryClient)
    }
  }
}
